import { render } from "./ContractViewPolicy.vue?vue&type=template&id=32743258&scoped=true"
import script from "./ContractViewPolicy.vue?vue&type=script&lang=js"
export * from "./ContractViewPolicy.vue?vue&type=script&lang=js"

import "./ContractViewPolicy.vue?vue&type=style&index=0&id=32743258&scoped=true&lang=css"
import "./ContractViewPolicy.vue?vue&type=style&index=1&id=32743258&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32743258"]])

export default __exports__